module.exports = __webpack_public_path__ + "static/img/logo.a0dfb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page1/logo.png
// module id = BmiR
// module chunks = 0